<template>
    <v-card class="main-content-card" flat>
        <v-toolbar flat>
            <v-toolbar-title>科研业绩表</v-toolbar-title>
        </v-toolbar>

        <v-divider/>

        <!-- 检索功能区 -->
        <v-form v-model="formValid" ref="formRef" lazy-validation>
            <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
                <v-layout row wrap>
                    <v-flex d-flex xs5>
                        <v-layout row wrap>
                            <v-flex xs12 sm3>
                                <x-select-user
                                        label="系统用户"
                                        v-model="user"
                                        :rules="rules.required"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-menu ref="refStartDate"
                                        :close-on-content-click="false"
                                        v-model="menuStartDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px">
                                    <v-text-field
                                            slot="activator"
                                            v-model="form.startDate"
                                            label="起始日期"
                                            clearable
                                            :rules="rules.startDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint/>
                                    <v-date-picker
                                            v-model="startDate"
                                            locale="zh-cn"
                                            @change="nv => form.startDate= nv">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-menu ref="refEndDate"
                                        :close-on-content-click="false"
                                        v-model="menuEndDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px">
                                    <v-text-field
                                            slot="activator"
                                            v-model="form.endDate"
                                            label="截止日期"
                                            clearable
                                            :rules="rules.endDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint/>
                                    <v-date-picker
                                            v-model="endDate"
                                            locale="zh-cn"
                                            @change="(nv) => form.endDate= nv"
                                            scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md2>
                                        <v-checkbox
                                                v-model="tblVisables"
                                                label="项目"
                                                value="project"
                                                hide-details/>
                                    </v-flex>
                                    <v-flex xs12 sm6 md2>
                                        <v-checkbox
                                                v-model="tblVisables"
                                                label="论文"
                                                value="paper"
                                                hide-details/>
                                    </v-flex>
                                    <v-flex xs12 sm6 md2>
                                        <v-checkbox
                                                v-model="tblVisables"
                                                label="论著"
                                                value="book"
                                                hide-details/>
                                    </v-flex>
                                    <v-flex xs12 sm6 md2>
                                        <v-checkbox
                                                v-model="tblVisables"
                                                label="奖励"
                                                value="award"
                                                hide-details/>
                                    </v-flex>
                                    <v-flex xs12 sm6 md2>
                                        <v-checkbox
                                                v-model="tblVisables"
                                                label="知识产权"
                                                value="property"
                                                hide-details
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex d-flex xs7 text-xs-left>
                        <div>
                            <v-btn
                                    color="primary"
                                    :dark="!loading"
                                    :disabled="loading"
                                    @click="onSearch">
                                <v-icon>search</v-icon>
                                检索
                            </v-btn>
                            <v-btn color="orange"
                                   :dark="!(loading || !tblDataReady)"
                                   v-print="'#printMe'"
                                   :disabled="loading || !tblDataReady">
                                <v-icon>print</v-icon>
                                打印
                            </v-btn>

                            <v-btn color="light-green" class="white--text"
                                   target="_blank"
                                   :disabled="loading || !tblDataReady"
                                   :href="pdfUrl">
                              <v-icon dark >save_alt</v-icon>导出业绩表PDF
                            </v-btn>
                            <v-btn color="pink" class="white--text"
                                   :disabled="loading || !tblDataReady"
                                   @click="sealNoteDialog=true">
                              <v-icon dark >local_play</v-icon>导出业绩表PDF(带公章)
                            </v-btn>
                            <!-- <v-btn color="primary" class="ml-3"-->
                            <!--  target="_blank"-->
                            <!--     :href="htmlUrl">HTML-->
                            <!-- </v-btn>-->
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>

        <v-divider/>
        <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>
        <v-dialog v-model="sealNoteDialog" width="500">
            <v-card>
                <v-card-title>请填写业绩表用途</v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-textarea label="用途"
                                :rules="rules.note"
                                hint="填写内容将打印在报表的左下角（限10字以内）。"
                                persistent-hint
                                counter
                                v-model="form.note"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn flat @click="onCancel">取消</v-btn>
                    <v-btn color="primary"
                           target="_blank"
                           @click="sealNoteDialog=false"
                           :href="pdfSealUrl"
                           :disabled="form.note.trim().length < 1 || form.note.trim().length > 10">确定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card-text>
            <div v-if="!tblDataReady"
                 style="height: 24px;line-height: 24px;">
                <v-icon color="primary">info</v-icon>
                <p style="display: inline-block;vertical-align: super;line-height: normal;">
                    请输入起止日期，检索获取结果后，点击打印按钮。
                </p>
            </div>
            <prt-table
                    v-else
                    :tbl-data="tblData"
                    :tbl-visable="tblVisables"
                    :admin-dept="true"
            />
        </v-card-text>
    </v-card>

</template>

<script>
    import XSelectUser from '@/components/global/SystUserSelect'
    import PrtTable from './Table'

    const baseUri = '/api/staf/print';

    const startYear = new Date().getFullYear() - 5;

    export default {
        components: {XSelectUser, PrtTable},
        data() {
            return {
                formValid: false,
                form: {
                    startDate: `${startYear}-01-01`,
                    endDate: new Date().toISOString().split('T')[0],
                    note: ""
                },

                sealNoteDialog: false,
                user: {},

                menuStartDate: false,
                startDate: null,

                menuEndDate: false,
                endDate: null,


                loading: false,
                tblDataReady: false,
                tblData: {},

                tblVisables: ['project', 'paper', 'book', 'award', 'property', 'achivement'],

                rules: {
                    required: [
                        v => !!v || "必填项。"
                    ],
                    startDate: [
                        v => !!v || "必填项。",
                        v => window.xutil.regexpDate().test(v) || '日期格式错误'
                    ],
                    endDate: [
                        v => !!v || "必填项。",
                        v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                        v => (v && v > this.form.startDate) || "截止日期必须晚于起始日期。"
                    ],
                    note: [v => (v && v.length <= 10) || '长度必须小于10个字符。']
                }

            }
        },

        computed: {
            pdfUrl() {
                // window.console.log(this.form);
                const url = `/api/staf/print/export/pdf/${this.user.dbid}`
                return window.xutil.buildUrl(url, this.form)
            },
            pdfSealUrl() {
                // window.console.log(this.form);
                const url = `/api/staf/print/export/pdf/seal/${this.user.dbid}`
                return window.xutil.buildUrl(url, this.form)
            },
            htmlUrl() {
                // window.console.log(this.form);
                const url = `/api/staf/print/export/html/${this.user.dbid}`
                return window.xutil.buildUrl(url, this.form)
            },
        },

        methods: {
            onCancel() {
                this.sealNoteDialog = false;
                this.form.note = ""
            },
            onSearch() {
                if (!(this.$refs.formRef.validate())) return;

                this.loading = true;
                this.axios
                    .get(`${baseUri}/${this.user.dbid}`, {params: this.form})
                    .then(rsp => {
                        this.tblData = rsp.data;
                        window.console.log("this.tblData")
                        window.console.log(this.tblData)
                        this.loading = false;
                        this.tblDataReady = true;
                    });
            }
        }
    }
</script>

